<template>
  <div class="asc-signature-embedded-container">
    <div
      id="dash-app"
      :ref="`signature_embed_container_${plotlyUID}`"
      :key="plotlyUID"
    ></div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'AscSignatureEmbedded',

  props: {
    plotlyData: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      plotlyUID: uuidv4(),
    }
  },

  watch: {
    plotlyData(newValue) {
      if (this.plotlyData) {
        this.updatePlotlyToken(newValue)
      }
    },
  },

  methods: {
    updatePlotlyToken(data) {
      const callback = {
        featuredeatilsselection: (
          platform,
          airline,
          featureName,
          component,
          occurenceCount,
          featureText,
        ) => {
          if (featureName) {
            this.$router.push({
              name: 'Feature Details',
              query: {
                airline: this.$route.query.airline,
                airlineDisplayName: this.$route.query.airlineDisplayName,
                platform: this.$route.query.platform,
                lastModifiedDate: this.$route.query.lastModifiedDate,
                feature: featureName,
                component: component,
                occurence: occurenceCount,
                airlineId: this.$route.query.airlineId,
                masterModelId: this.$route.query.masterModelId,
                featureText: featureText,
              },
            })
          }
        },
      }
      window.dash_embedded_component.renderDash(
        {
          url_base_pathname: data.url,
          auth_token: data.token,
        },
        this.$refs[`signature_embed_container_${this.plotlyUID}`],
        { callback },
      )
    },
  },
}
</script>

<style lang="scss" scoped></style>
